module.exports = __webpack_public_path__ + "static/media/celebration-preview-slack.711f3e37.svg";